import i18n from "~/i18n/i18n";

const linkedEmailAccountStatus = (
	connected: boolean,
	mailboxAddress: null | string | undefined,
	grantsSendScope: boolean
): string => {
	if (!connected || !mailboxAddress) return i18n.t("preferences.linkedEmail.profileStatus.notLinked", { ns: "common" });

	return grantsSendScope
		? i18n.t("preferences.linkedEmail.profileStatus.connected", { mailboxAddress, ns: "common" })
		: i18n.t("preferences.linkedEmail.profileStatus.draftsOnly", { mailboxAddress, ns: "common" });
};

export default linkedEmailAccountStatus;
